import Ajv2019 from 'ajv/dist/2019';
import { Style, componentManifestSchema } from '../schema';

class StyleBase {
  protected style: Style;

  constructor(style?: Style) {
    this.style = style || {};
  }

  public static validate(style: Style) {
    const ajv = new Ajv2019({ allErrors: true });
    const ajvValidate = ajv.compile(componentManifestSchema.$defs.style);

    const valid = ajvValidate(style);

    return {
      valid,
      errors: ajvValidate.errors
    };
  }

  public setStyle(style: Style) {
    this.style = style;
    return this;
  }

  public getStyle() {
    return this.style;
  }
}

export default StyleBase;
